import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import { editHeaveyColli, updateHeaveyColli } from "../../../store/actions"

import { useEffect, useState } from "react"

const EditHeavey = props => {
  const dispatch = useDispatch()
  document.title = "Edit Heavy"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editHeaveyColli(id))
  }, [dispatch])

  const heavey = useSelector(state => state.heaveyColli)

  useEffect(() => {
    let heavy = []
    if (heavey && heavey.heaveyColli && heavey.heaveyColli.length > 0) {
      heavy = heavey.heaveyColli.filter(heaveyColli => heaveyColli.id == id)
    }
    if (heavy.length > 0) {
      setDetails(heavy[0])
    } else {
      props.history.push("/dropdown/heavey_colli/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      colli_id: details && details.colli_id ? details.colli_id : "",

      colli_name: details && details.heavy_collis ? details.heavy_collis : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      colli_name: Yup.string().required("Please enter heavey colli"),
    }),
    onSubmit: values => {
      values.colli_id = id // colli_id is from api thats why this needs to be same with "id"
      dispatch(updateHeaveyColli(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.heaveyColli.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Heavey Colli" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editHeaveyForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="heavey">Heavey Colli</Label>
                          <Input
                            name="colli_name"
                            type="text"
                            id="heavey"
                            placeholder="Enter heavey colli"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.colli_name || ""}
                          />
                          {validation.touched.colli_name &&
                          validation.errors.colli_name ? (
                            <FormFeedback type="invalid">
                              {validation.errors.colli_name}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {heavey && heavey.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditHeavey
